
//source: https://www.tutorialspoint.com/how-to-convert-date-to-string-in-typescript
export const dateFormat = function date_TO_String(date_Object: Date): string {
    // helper to zero-pad numbers to two digits
    const pad = (n: number) => String(n).padStart(2, '0');
    // get the year, month, date, hours, and minutes seprately and append to the string.
    const date_String: string =
        date_Object.getFullYear() +
        "-" +
        pad(date_Object.getMonth() + 1) +
        "-" +
        pad(date_Object.getDate()) +
        " " +
        pad(date_Object.getHours()) +
        ":" +
        pad(date_Object.getMinutes());
    return date_String;
}

// source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export const sizeFormat = function formatBytes(bytes: number) {
    const decimals = 1
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['B', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}